import { createFileRoute } from '@tanstack/react-router';
import { LocalizedPage, loadLocalizedPage, localizedPageHead } from '~/lib/localized-page';

export const Route = createFileRoute('/$locale/$')({
  loader: ({ params }) =>
    loadLocalizedPage(params.locale, `/${params._splat?.replace(/^\/+|\/+$/gu, '') ?? ''}`),
  head: ({ loaderData }) => localizedPageHead(loaderData),
  component: LocalizedSplatPage,
});

function LocalizedSplatPage() {
  return <LocalizedPage data={Route.useLoaderData()} />;
}
